import { useQuery } from '@tanstack/react-query';
import { getClinicAdmin } from '@/services/admin/clinicUsers';

/**
 * Query hook to fetch the 管理者権限 user of a clinic (admin portal).
 *
 * Used by the 治療院ユーザー form to disable 管理者権限 when the clinic already has one.
 */
export const useClinicAdminQuery = (siteType: string, clinicId?: number | null) => {
  return useQuery({
    queryKey: ['admin', 'clinics', siteType, clinicId, 'clinic-admin'],
    queryFn: () => getClinicAdmin(siteType, clinicId as number),
    enabled: !!siteType && clinicId != null && clinicId > 0,
  });
};
